import * as React from 'react';
import { observer } from 'mobx-react';
import BottomNav from '@src/business-components/bottom-nav';
import Page from '@src/components/page';
import BaseSwiper from '@src/components/swiper/base-swiper';
import useStore from '@src/utils/hooks/use-store';
import CourseStore from '@src/pages/course/store';

const styles = require('./index.less');
const pageBackground = require('./images/page-background.jpg');
const moreBenefitsSlides = [1, 2, 3, 4, 5].map(index => require(`./images/swiper-img${index}.png`));

const Course = () => {
  const store = useStore(() => new CourseStore());

  return <Page className={styles.root}>
      <main className={styles.page} style={{ backgroundImage: `url(${pageBackground})` }} aria-label="更多内容">
        <div className={styles.monthCardDescription}>
          <p>首个生态服专属，激活月卡除月卡福利外，</p>
          <p>
            还将在新服【{store.serverName}】获得<strong>对怪物攻击伤害加50%的buff</strong>，
          </p>
          <p>升级效率大大提升，抢夺资源更是快人一步！</p>
        </div>
        <div className={styles.goldSetDescription}>
          <p>
            69级即可<strong>免费获得全套黄金套</strong>，新服【{store.serverName}】创角起35天内，
          </p>
          <p>
            达到60级且累计签到3天即可获得<strong>6技能同伴-白秋琳！</strong>
          </p>
          <p>还有强者之路、剑侠征程</p>
          <p>
            <strong>海量材料、玄晶、绑金、珍珠贝</strong>等好礼助阵大侠征战新服！
          </p>
        </div>
        <div className={styles.anniversaryDescription}>
          <p className={styles.anniversaryActivityTime}>活动时间：10月13日-11月7日23:59</p>
          <p style={{ marginTop: '4px' }}>根据10月13日-11月7日期间累计消耗</p>
          <p>金额可领取对应数量的财运红包，</p>
          <p>每档限领1次不可重复领取（参与购买“特惠礼包”的大侠，</p>
          <p>可在新服【{store.serverName}】领取所购礼包时，</p>
          <p>获得对应特惠礼包金额的消耗积分）。</p>
        </div>
        <div className={styles.moreBenefitsDescription}>
          <p>10月13日起，关注“剑侠世界端游”、“剑世福利官”微信号可</p>
          <p>
            分别领取<strong>新服[VIP礼包]</strong>以及<strong>[侠聚华年福利官礼包]</strong>，
          </p>
          <p>内含大量珍珠贝、绑金、玄晶等好礼，礼包数量有限先到先得！</p>
          <p>
            10月8日-10月13日期间参与<strong>新服预创建</strong>，
          </p>
          <p>开服将获得价值200元的开服礼包！</p>
        </div>
        <div className={styles.activityRulesContent}>
          <section>
            <h3>一、新服预约</h3>
            <p>活动时间：10月8日-11月16日23:59</p>
            <p>
              ·通过绑定身份证和手机验证的大侠，可在新服<strong>【{store.serverName}】</strong>开服后领取
              <strong>
                {/*{store.bindGoldText}*/}
                35万绑金+云游戏1小时时长。
              </strong>
            </p>
            <p>同1个绑定身份证或绑定手机下仅可验证1个账号，一经验证不可取消。</p>
          </section>
          <section>
            <h3>二、特惠礼包</h3>
            <p>特惠价时间：10月8日-10月13日18:00</p>
            <p>补买价时间：10月13日18:01-11月16日23:59</p>
            <p>
              特惠、补买时间所购礼包内容相同，但价格不同，<strong>补买价格高于特惠价格</strong>（钜惠团购礼包价格不变）。
            </p>
            <p>
              ·钜惠组队礼包、特惠礼包、超值礼包、精致礼包、豪华礼包、尊享礼包、雷霆印礼包壹、雷霆印礼包贰和雷霆印礼包叁九种超值礼包，登陆账号后即可购买。<strong
              >
                每个账号每种礼包限购1次
              </strong>，同种礼包多次购买为无效购买，因超低折扣不予退款，请谨慎购买！
            </p>
            <p>
              ·钜惠组队礼包两人组队购买，可额外获得<strong>御赐仙鹤绣金囊[18格]</strong>奖励！大侠点击“创建购买队伍”购买成功后，将生成专属邀请链接，分享好友，好友通过邀请链接“加入购买队伍”完成购买，即两人组队购买成功。
            </p>
            <p>
              ·未完成实名认证的账号请<strong>“点击”</strong>完成实名认证后参与购买；如遇支付码失效，可稍作等待后刷新页面再尝试支付。
            </p>
            <p>·支付订单有效期2分钟，有效期内不可切换双端支付。</p>
          </section>
          <section>
            <h3>三、领奖说明</h3>
            <p>领奖时间：10月13日-11月19日23:59</p>
            <p>礼包有效期截止：11月30日23:59</p>
            <p>
              领奖方式：新服<strong>【{store.serverName}】</strong>点击游戏画面顶部<strong>“开服狂欢”-“百万绑金”和“预约好礼”</strong>界面领取。
            </p>
            <p>·参与新服预约、购买特惠礼包的账号，限在领奖时间内激活账号下1个角色领取对应奖励，激活角色唯一。</p>
            <p>
              <strong>·通过此活动获得的绑金将根据开服天数和等级进行分次领取。</strong>
            </p>
            <p>
              <strong>
                ·奖励内容均为绑定，不支持更换账号及角色领取，且限账号下1个角色领取。当角色确认领取后，绑金及礼包的领取资格将不可更换，每种礼包最多领取1次，不可多次领取，未领取完奖励的大侠请不要进行角色交易，会导致奖励无法领取，且不作退还！
              </strong>
            </p>
          </section>
          <p className={styles.ruleFooter}>以上内容仅供参考，具体以游戏内实际情况为准！</p>
        </div>
        <div className={styles.moreBenefitsCarousel} aria-label="更多福利轮播图">
          <BaseSwiper store={store.moreBenefitsSwiper}>
            {moreBenefitsSlides.map((slide, index) => <div className={styles.moreBenefitsSlide} key={slide}>
                <img src={slide} alt={`更多福利${index + 1}`} />
              </div>)}
          </BaseSwiper>
        </div>
      </main>
      <BottomNav active="COURSE" />
    </Page>;
};

export default observer(Course);
